<template>
  <div class="settings">
    <div class="content-wrapper">
      <RouterView />
    </div>
  </div>
</template>
